export var IS_AX_CLASS = Symbol('AX class marker');
